const PARTICIPANT_TOKEN_KEY = 'ipb_participant_jwt';

export function setParticipantToken(token: string): void {
  sessionStorage.setItem(PARTICIPANT_TOKEN_KEY, token);
}

export function clearParticipantToken(): void {
  sessionStorage.removeItem(PARTICIPANT_TOKEN_KEY);
}

export function getParticipantToken(): string | null {
  return sessionStorage.getItem(PARTICIPANT_TOKEN_KEY);
}

export interface ApiError {
  status: number;
  code?: string;
  message: string;
}

function tryParseApiJson(text: string): { ok: true; value: unknown } | { ok: false } {
  const t = text.trim();
  if (!t) return { ok: true, value: null };
  if (t[0] !== '{' && t[0] !== '[') return { ok: false };
  try {
    return { ok: true, value: JSON.parse(t) as unknown };
  } catch {
    return { ok: false };
  }
}

export async function apiFetch<T = unknown>(
  path: string,
  init: RequestInit = {},
  options: { withParticipant?: boolean } = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set('content-type', 'application/json');
  if (options.withParticipant) {
    const token = getParticipantToken();
    if (token) headers.set('authorization', `Bearer ${token}`);
  }
  const res = await fetch(path, {
    ...init,
    headers,
    credentials: 'include',
  });
  const text = await res.text();
  const parsed = tryParseApiJson(text);
  const data = parsed.ok ? parsed.value : null;

  if (!res.ok) {
    const snippet = text.replace(/\s+/g, ' ').trim().slice(0, 200);
    const err: ApiError = {
      status: res.status,
      code: parsed.ok ? (data as { code?: string } | null)?.code : undefined,
      message: parsed.ok
        ? ((data as { message?: string; error?: string } | null)?.message ??
          (data as { error?: string } | null)?.error ??
          `Errore HTTP ${res.status}`)
        : snippet || `Errore HTTP ${res.status} (risposta non JSON)`,
    };
    throw err;
  }

  if (!parsed.ok) {
    throw {
      status: res.status,
      message: 'Risposta API non valida (non JSON)',
    } satisfies ApiError;
  }

  return data as T;
}
